<template>
  <div id="askExam" v-cloak>
    <!-- Logo -->
    <div class="LogoBorder">
      <img :src="logoUrl" alt="">
      <div>|</div>
      <div>弘成慧考平台</div>
    </div>
    <!-- Info -->
    <div class="Main">
      <div v-if="isShowFlag">
        <div class="list">
          <span class="label">学生姓名</span>
          <span class="label">：</span>
          <p class="text">{{Info.studentName}}</p>
        </div>
        <div class="list">
          <span class="label">证件号码</span>
          <span class="label">：</span>
          <p class="text">{{Info.cardNo}}</p>
        </div>
        <div class="list">
          <span class="label">考试批次</span>
          <span class="label">：</span>
          <span class="text">{{Info.planName}}</span>
        </div>
        <div class="list">
          <span class="label">报名日期</span>
          <span class="label">：</span>
          <p class="text">{{Info.signDate}}</p>
        </div>
        <div class="list">
          <span class="label">报考科目</span>
          <span class="label">：</span>
          <span class="text">{{Info.courseName}}</span>
        </div>
      </div>
      <div v-else class="errInfoCss">
        <span class="warning-red">×</span>
        {{ errInfo }}
      </div>
    </div>

    <div class="Main" style="margin-top: 24px;" v-if="isShowFlag">
      <div v-if="isSubmitted">
        <div class="marginTop">
            <span>为方便后续排考安排，请您确认是否参加考试</span>
        </div>

        <div class="divButton">
            <el-button :type="btnType1" :disabled="submitFlag" @click="setJoinExamFlag(0)">不参加</el-button>
            <el-button :type="btnType2" :disabled="submitFlag" @click="setJoinExamFlag(1)" style="margin-left: 30px;">参加</el-button>
        </div>

        <div class="divInput">
            <span>如果选择不参加，请录入无法参加的原因：</span>
            <el-input
                v-model="reasonDesc"
                type="textarea"
                :rows="3"
                placeholder="请在此输入无法参加的原因"
                maxlength="200"
                show-word-limit
                :disabled="submitFlag"
            ></el-input>
        </div>

        <div class="marginBottom">
            <el-button type="primary" @click="submitForm" :disabled="submitFlag">提交</el-button>
        </div>
      </div>
      <div v-else class="expireCss">
        参考确认数据已失效
      </div>
    </div>

  </div>
</template>
<script>
  import { Toast } from "vant";
  export default {
    data() {
      return {
        isShowFlag: true,
        isSubmitted: true,
        errInfo: '',
        joinExamFlag: 2,
        reasonDesc: '',
        logoUrl: '',
        Info: {},
        submitFlag: false
      }
    },
    created() {
      this.getInfo()
    },
    computed: {
        btnType1() {
            return this.joinExamFlag === 0 ? 'primary' : '';
        },
        btnType2() {
            return this.joinExamFlag === 1 ? 'primary' : '';
        }
    },
    methods: {
        async getInfo() {
            const { t : tenant, ps : planStudentId} = this.$route.query
            this.$api.system.getSystemNameFN({ tenant }).then(res=>{
                this.logoUrl = res.data.isUsedLogo == 1 ? res.data.logoUrl ? res.data.logoUrl : require("@/assets/img/customDefault.png") : require("@/assets/img/customDefault.png")
            })
            let params = {
                tenant : tenant,
                planStudentId : planStudentId,
            }
            const { code:code1,data:data1,error:error1 } = await this.$api.system.getPlanStudentInfoFn(params)
            if(code1 === 1){
                this.Info = data1;
            }else{
                this.isShowFlag = false;
                this.errInfo = error1;
                return;
            }
            const { code:code2,data:data2 } = await this.$api.system.getPlanStudentAskFn(params)
            if(code2 === 1){
                this.isSubmitted = true;
                if(data2){
                  this.joinExamFlag = [0,1].includes(data2?.joinExamFlag) ? data2.joinExamFlag : 2;
                  this.reasonDesc = data2?.reasonDesc;
                  this.submitFlag = [0,1].includes(data2?.joinExamFlag) ? true : false;
                }
            }else{
                this.isSubmitted = false;
            }
        },
        setJoinExamFlag(val){
            this.joinExamFlag = val;
        },
        async submitForm(){
            if(this.joinExamFlag === 2){
                Toast('请选择是否参加考试!');
                return;
            }
            if(this.joinExamFlag == 0 && !this.reasonDesc){
                Toast('请输入无法参加考试的原因!');
                return;
            }
            const { t: tenant,ps: planStudentId } = this.$route.query
            const params = {
                tenant: tenant,
                planStudentId: planStudentId,
                joinExamFlag: this.joinExamFlag,
                reasonDesc: this.reasonDesc
            }
            const {code} = await this.$api.system.savePlanStudentAskFn(params)
            if(code === 1){
              this.submitFlag = true;
              Toast('提交成功');
            }
        }
    },
  }
</script>

<style scoped lang="less">
[v-clock] {
  display: none
}
#askExam {
  width: 100%;
  height: auto;
  min-height: 100%;
  background: rgba(255, 245, 248, 1);
  background: url("../../assets/img/placeInfo_bg.png") no-repeat;
  background-size: 100% 3.2rem;
  padding: 0 .38rem;
  overflow: hidden;
  box-sizing: border-box;
  .LogoBorder {
    width: 100%;
    height: 1.5rem;
    padding-top: .5rem;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 0.32rem;
    &>img {
      width: auto;
      height: .8rem;
    }
    &>div {
      color: #FFF;
      line-height: .8rem;
      margin: 0 .2rem;
      font-size: .48rem;
      font-display: optional;
      font-family: initial !important;
      font:initial;
      font-weight: 500;
    }
    &>div:first-of-type {
      color: rgba(255, 255, 255, 0.3);
    }
  }
  .Main {
    width: 100%;
    background: #FFF;
    border-radius: .2rem;
    padding-top: .5rem;
    font-display: optional;
    font-family: initial !important;
    font:initial;
    font-display: block;
    box-shadow: #737780 0 0 .1rem;
    font-size: .38rem;
    .list {
      padding: 0 .4rem;
      box-sizing: border-box;
      padding-bottom: .4rem;
      display: flex;
      .label:first-child {
        color: #737780;
        display: inline-block;
        width: 1.8rem;
        line-height: .5rem;
        text-align: justify;
        text-align-last: justify;
        font-size: .38rem;
      }
      .text {
        word-wrap: break-word;
        word-break: break-all;
        display: inline-block;
        color: #2D2F33;
        line-height: .5rem;
        max-width: 6.5rem;
        height: auto;
      }
    }
    .marginTop{
        text-align: center;
        span {
            margin: 0 auto;
            padding:5px 10px 5px 10px;
            border-radius: .1rem;
            color: #737780;
            font-size: 15px;
        }
    }
    .divButton{
        text-align: center;
        margin-top: 20px;
    }
    .divInput{
        width: 90%;
        margin: 0 auto;
        margin-top: 20px;
        span{
            display: block;
            line-height: 25px;
            padding-left:4px;
            color: #737780;
            font-size: 13px;
        }
    }
    .marginBottom{
        line-height: 80px;
        text-align: center;
    }
    .expireCss{
        text-align: center;
        color:darkgrey;
        height: 80px;
        line-height: 60px;
    }
  }
  .warning-red{
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
    color: white;
    text-align: center;
    line-height: 19px;
    font-weight: bold;
    position: relative;
    font-size: 15px;
    margin-right: 3px;
  }
  .errInfoCss{
    color: #737780;
    text-align: center;
    height: 130px;
    line-height: 100px;
  }
}
</style>